import { geojson } from "flatgeobuf";
import { buildSourceUrl, convertGeometry, debounce } from "./helpers";
import { Feature } from "ol";
import { layersVectorSource } from "./vector-sources";
import { layersSourceFilenames } from "./sources";
import { layersWMS } from "./layers";
import ImageLayer from "ol/layer/Image";
import { ImageWMS } from "ol/source";
import { layerController } from "./layer-controller";

/**
 *
 * @param {VectorSource} source
 * @param {string} url
 * @param {{minX: number, minY: number, maxX: number, maxY: number}} rect
 */
const updateSource = (source, url, rect) => {
    source.setLoader(async function () {
        console.log("update", url);
        // Use flatgeobuf JavaScript API to iterate features as geojson.
        // Because we specify a bounding box, flatgeobuf will only fetch the relevant subset of data,
        // rather than the entire file.
        const features = geojson.deserialize(url, rect);
        for await (let feature of features) {
            //feature.getGeometry().transform('EPSG:4326', 'EPSG:3857')
            // console.log(feature);
            if (!feature.properties.gid && !feature.properties.id) continue;
            const id = feature.properties.gid || feature.properties.id;
            const f = new Feature(convertGeometry(feature.geometry));
            f.setId(id);
            // f.setProperties(feature.properties);
            f.setProperties({ url, ...feature.properties });
            this.addFeature(f);
            // console.log(f);
        }
        console.log("finished", url);
    });
    source.refresh();
};

const updateAllLayers = (rect) => {
    if (layerController.currentMap == "gna") {
        updateSource(
            layersVectorSource.GNA.punti,
            buildSourceUrl(layersSourceFilenames.GNA.punti),
            rect
        );
        updateSource(
            layersVectorSource.GNA.linee,
            buildSourceUrl(layersSourceFilenames.GNA.linee),
            rect
        );
        updateSource(
            layersVectorSource.GNA.poligoni2,
            buildSourceUrl(layersSourceFilenames.GNA.poligoni2),
            rect
        );
        updateSource(
            layersVectorSource.GNA.progetti,
            buildSourceUrl(layersSourceFilenames.GNA.progetti),
            rect
        );
        updateSource(
            layersVectorSource.GNA.ricostruitiLinee,
            buildSourceUrl(layersSourceFilenames.GNA.ricostruitiLinee),
            rect
        );
        updateSource(
            layersVectorSource.GNA.ricostruitiPoligoni,
            buildSourceUrl(layersSourceFilenames.GNA.ricostruitiPoligoni),
            rect
        );
    }

    if (layerController.currentMap == "iccd") {
        updateSource(
            layersVectorSource.ICCD,
            buildSourceUrl(layersSourceFilenames.ICCD),
            rect
        );
    }

    if (layerController.currentMap == "concessione") {
        updateSource(
            layersVectorSource.Concessione,
            buildSourceUrl(layersSourceFilenames.Concessione),
            rect
        );
    }

    if (layerController.currentMap == "altre-banche-dati") {
        updateSource(
            layersVectorSource.AltreBancheDati.censimento,
            buildSourceUrl(layersSourceFilenames.AltreBancheDati.censimento),
            rect
        );

        updateSource(
            layersVectorSource.AltreBancheDati.tess,
            buildSourceUrl(layersSourceFilenames.AltreBancheDati.tess),
            rect
        );
    }
};

export { updateAllLayers };
